import { useStore } from 'effector-react';
import { css } from 'linaria';
import { MountMode } from 'model/domain';
import { isInquire$ } from 'model/main.model';
import { FunctionalComponent, h } from 'preact';
import { Footer } from 'ui/footer';
import { Modal } from 'ui/modal';

import { themeClass } from 'ui/theme';

export const FallbackContainer: FunctionalComponent<{ mode: MountMode }> = (props) => {
	const { children, mode } = props;
	const isInquire = useStore(isInquire$);

	return (
		<div className={themeClass} data-verify-container={'true'}>
			{mode === MountMode.inline ? (
				<div className={content}>
					{children}
					<Footer/>
				</div>
			) : (
				<Modal
					contentClassName={content}
				>
					{children}
					{!isInquire && <Footer/>}
				</Modal>
			)}
		</div>
	);
};

const content = css`
  display: flex;
  flex-direction: column;
  background-color: var(--background);
  max-width: 520px;
  min-width: 520px;
  width: 100%;
  max-height: 450px;
  min-height: 450px;
  height: 100%;
  border-radius: 8px;
  position: relative;
`;
